<template>
<svg viewBox="0 0 17 17" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-SuoBaiSe`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.19345 8.41165C6.86012 7.87832 6.72678 7.27832 6.72678 6.61165C6.72678 4.74499 8.19345 3.27832 10.0601 3.27832C11.9268 3.27832 13.3935 4.74499 13.3935 6.61165C13.3935 8.47832 11.9268 9.94499 10.0601 9.94499C9.32678 9.94499 8.72678 9.74499 8.12678 9.34499L6.59345 10.8783L7.32678 11.6117L6.39345 12.545L5.66012 11.8117L5.19345 12.2783L5.92678 13.0117L4.99345 13.945L3.32678 12.2783L7.19345 8.41165ZM10.0601 4.61165C8.92678 4.61165 8.06012 5.47832 8.06012 6.61165C8.06012 7.74499 8.92678 8.61165 10.0601 8.61165C11.1934 8.61165 12.0601 7.74499 12.0601 6.61165C12.0601 5.47832 11.1268 4.61165 10.0601 4.61165Z"/></svg>
</template>
<script>

export default {
  name: 'IconSuoBaiSe',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
